import {
  GET_UNREAD_MESSAGE_COUNT,
  GET_UNREAD_MESSAGE_COUNT_FAILED,
  RECEIVE_UNREAD_MESSAGE_COUNT
} from './actions';

const initialState = {
  unreadMessageCount: 0,
  isFetching: false,
  error: null,
};

const flowmedikCareConversationsReducer = (state = initialState, action) => {
  let { type } = action;
  switch (type) {
    case GET_UNREAD_MESSAGE_COUNT: {
      return {
        ...state,
      };
    }
    case RECEIVE_UNREAD_MESSAGE_COUNT: {
      return {
        ...state,
        unreadMessageCount: action.payload
      };
    }
    case GET_UNREAD_MESSAGE_COUNT_FAILED: {
      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

export { flowmedikCareConversationsReducer };
